export const getJwt = () => {
    return localStorage.getItem('user_jwt');
};


export const getUser = () => {

    var s = localStorage.getItem('user');

    return s;
};

export const hasPermission = (permission) => {
    const perms = localStorage.getItem('perms');
    if (!perms || perms == '') {
        return false;
    } else if (perms.split(',').find(p => p == permission)) {
        return true;
    }else return false;
};

export const hasMainPanelRead = () => {
    return hasPermission('MAIN_PANEL_READ');
};

export const hasMainPanelAlarmStatusChange = () => {
    return hasPermission('MAIN_PANEL_ALARM_STATUS_CHANGE');
};

export const hasPackagingLinesView = () => {
    return hasPermission('PACKAGING_LINES_VIEW');
};

export const hasPackagingLinesFullAccess = () => {
    return hasPermission('PACKAGING_LINES_FULL_ACCESS');
};

export const hasFormatsView = () => {
    return hasPermission('FORMATS_VIEW');
};

export const hasFormatsFullAccess = () => {
    return hasPermission('FORMATS_FULL_ACCESS');
};

export const hasFormatsWithdrawn = () => {
    return hasPermission('FORMATS_WITHDRAWN');
};

export const hasFontManagementView = () => {
    return hasPermission('FONT_MANAGEMENT_VIEW');
};

export const hasFontManagementFullAccess = () => {
    return hasPermission('FONT_MANAGEMENT_FULL_ACCESS');
};

export const hasFastActingPartView = () => {
    return hasPermission('FAST_ACTING_PART_VIEW');
};

export const hasFastActingPartFullAccess = () => {
    return hasPermission('FAST_ACTING_PART_FULL_ACCESS');
};

export const hasProductionView = () => {
    return hasPermission('PRODUCTION_VIEW');
};

export const hasProductionFullAccess = () => {
    return hasPermission('PRODUCTION_FULL_ACCESS');
};

export const hasStoragePlaceView = () => {
    return hasPermission('STORAGE_PLACE_VIEW');
};

export const hasStoragePlaceFullAccess = () => {
    return hasPermission('STORAGE_PLACE_FULL_ACCESS');
};

export const hasAdminPanelView = () => {
    return hasPermission('ADMIN_PANEL_VIEW');
};

export const hasAdminPanelFullAccess = () => {
    return hasPermission('ADMIN_PANEL_FULL_ACCESS');
};



export const isSanofi = () => {
    return process.env.REACT_APP_COMPANY == "sanofi"
};


export const authHeader = () => {
    return {headers: {Authorization: `Bearer ${getJwt()}`}};
};

export const paramsSerializer = (params) => {
    return Object.entries(params).map(([key, value]) => `${key}=${value}`).join('&');
};